<template>
  <div class="un-pxtorem-login">
    <div class="un-pxtorem-contentBox">
      <div class="leftImg">
        <img src="../../icons/leftImg.png" class="un-pxtorem-leftImg">
      </div>
      <div class="un-pxtorem-loginBox">
        <img src="../../icons/icon_logo.png" class="un-pxtorem-img">
        <div class="un-pxtorem-iptDiv">
          <img src="../../icons/icon_drugstore.png">
          <input type="text" placeholder="药店名称/管理员手机号/机构ID" v-model="enterprise">
        </div>
        <div class="un-pxtorem-iptDiv">
          <img src="../../icons/icon_name.png">
          <input type="text" placeholder="请输入账号" v-model="loginName" maxlength="11" >
        </div>
        <div class="un-pxtorem-iptDiv">
          <img src="../../icons/icon_pwd.png">
          <input :type="isShowPwd?'text':'password'" placeholder="请输入登录密码" v-model="password" maxlength="16" >
          <img class="pwd" v-if="!isShowPwd" src="../../icons/eye_2.png" @click="showPwd" >
          <img class="pwd" v-else src="../../icons/eye_1.png" @click="showPwd" >
        </div>
        <div style="display:none" >{{ exitsVal }}</div>
        <div class="un-pxtorem-loginBtn" v-if="canClick" v-online-click='loginFn'>登录</div>
        <div class="un-pxtorem-loginBtn unClick" v-else >登录</div>
      </div>
    </div>
  </div>
</template>
<script>
import { toast } from '../../components/Toast'
import { toLogin } from '../../api/index'
import md5 from 'md5'


export default {
  components: {},
  data() {
    return {
      enterprise:'',
      loginName:'',
      password:'',
      loginType:2,
      isAjaxing :false,
      canClick:false,
      ifExist:'',
      isShowPwd:false

    }
  },
  created() {
    const loginName = this.db.getItem('loginName') || '';
    const enterprise = this.db.getItem('enterprise') || '';
    this.loginName = loginName;
    this.enterprise = enterprise;
  },
  computed:{
    exitsVal:function(){
        this.ifExist=Number(Boolean(this.enterprise))+Number(Boolean(this.loginName))+Number(Boolean(this.password));
    }
  },
  watch:{
    ifExist(newVal,oldVal){
      if(Number(newVal) === 3){
        this.canClick = true
      }else{
        this.canClick = false
      }
    }
  },
  methods: {
    //登录
    loginFn(){
      if(this.isAjaxing) return false;
      let { loginName, password, enterprise, loginType } = this;
      if(!enterprise){
        toast('请输入药店名称/管理员手机号/机构ID');
        return false;
      }
      if(!loginName){
        toast('请输入账号');
        return false;
      }
      if(!password){
        toast('请输入登录密码');
        return false;
      }
      password = md5(password)
      this.isAjaxing = true;
      toLogin({ loginName, password, enterprise, loginType  }).then(res => {
        const drugstoreName = res.drugstoreDto ? res.drugstoreDto.drugstoreName : '';
        this.db.setItem('employeeId', res.employeeId );
        this.db.setItem('drugstoreName', drugstoreName);
        this.db.setItem('loginName', loginName );
        this.db.setItem('enterprise', enterprise );
     
        window.location.href = `protocol://action/loginSuccess?token=${res.token}&organSign=${res.organSign}&drugstoreName=${drugstoreName}&enterprise=${enterprise}&loginName=${loginName}`
        this.isAjaxing = false;
      }).catch(res => {
        this.isAjaxing = false;
        toast(res.msg || res.result || res)
      })
    },
    showPwd(){
      this.isShowPwd = !this.isShowPwd;
    }
  }
}
</script>
<style >
.un-pxtorem-login{
  width:1366px;
  height:675px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  background:url('../../icons/loginbg.png');
  background-size: 100% 100%;
  box-sizing: border-box;
  display:flex;
  align-items:center;
  justify-content: space-around;
}
.un-pxtorem-contentBox{
  background: white;
  display: flex;
  height:576px;
  border-radius:14px;
}
.un-pxtorem-leftImg{
  width:380px;
  height:330px;
  margin:125px 0 0 92px;
}
.un-pxtorem-loginBox{
  margin:107px 100px 0 130px
}
.un-pxtorem-img{
  width:220px;
  height:58px;
  margin:0 18px 40px;
}
.un-pxtorem-iptDiv{
  display: flex;
  border-bottom: 1px solid #F6F6F6;
  padding: 8px 0;
  margin-top:20px
}
.un-pxtorem-iptDiv img{
  width:22px;height:22px;margin-right:5px
}
.un-pxtorem-iptDiv img.pwd{
  width:18px;height:18px;
}
.un-pxtorem-iptDiv input{
  border: none;
  width:236px
}
.un-pxtorem-loginBtn{
  width:256px;height:49px;border-radius:25px;line-height:49px;font-size:14px;margin-top:30px;
  background:rgba(0,121,242,1);
  text-align: center;
  color: white;
}
.unClick{
  background:#ccc;
}

</style>
